<template>
  <div class="filters">
    <h2 class="filters__heading">
      <img class="filters__icon"
        :src="require(`@/assets/themes/${BRAND_KEY}/images/icon-filter.svg`)" />
      {{ $t("FILTER_BY") }}
    </h2>
    <v-select
      class="select"
      :options="[
        { label: 'iOS', value: 'ios' },
        { label: 'Cydia', value: 'cydia' },
        { label: 'macOS (AppStore)', value: 'osx' },
        { label: 'macOS (Standalone)', value: 'standalone' },
        { label: 'Apple TV', value: 'tvos' },
        { label: $t('BOOKS'), value: 'books' },
      ]"
      :reduce="(item) => item.value"
      :value="type"
      :clearable="false"
      :searchable="false"
      @input="updateParams({ type: $event, genre: null })"
    ></v-select>
    <v-select
      class="select"
      :value="genre"
      :options="genres"
      :searchable="false"
      :reduce="(item) => item.value"
      :placeholder="$t('CATEGORY')"
      @input="updateParams({ genre: $event })"
    ></v-select>
    <v-select
      class="select"
      :value="price"
      :options="[
        { label: $t('PAID'), value: '1' },
        { label: $t('FREE'), value: '2' },
      ]"
      :reduce="(item) => item.value"
      :searchable="false"
      :placeholder="$t('PRICE')"
      @input="updateParams({ price: $event })"
    ></v-select>
  </div>
</template>

<script>
export default {
  props: ['type', 'genre', 'price'],
  computed: {
    genres() {
      if (!this.$store.getters.genres[this.type]) {
        return [];
      }

      return Object.entries(this.$store.getters.genres[this.type])
        .map(genre => ({ label: this.$t(genre[1].name.toUpperCase()), value: genre[0] }));
    },
  },
  methods: {
    updateParams(obj) {
      const params = { ...this.$route.query, ...obj };
      Object.keys(params).forEach((key) => {
        if (!params[key]) {
          delete params[key];
        }
      });
      this.$router.push({ query: params });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.filters {
  &::v-deep {
    input {
      transition: none;
      font-size: 16px;

      &::placeholder {
        font-size: 14px;
      }
    }
  }

  &__heading {
    display: flex;
    align-items: center;
    font-size: 16px;

    @include notebook {
      margin-bottom: 10px;
    }
  }

  &__icon {
    margin-right: 5px;
  }
}

.select {
  background-color: var(--tertiary-bg);
  margin-top: 10px;
  border-radius: 3px;
  position: relative;

  @include notebook {
    display: inline-block;
    width: 200px;
    margin-top: 0;
    margin-right: 5px;
  }

  @media (max-width: 767px) {
    display: block;
    width: 100%;
    margin-top: 5px;
  }

  &:after {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    right: 8px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 5px 5px 0 5px;
    border-color: $text-secondary transparent transparent transparent;
    pointer-events: none;
  }

  &::v-deep {
    .vs__search {
      &::placeholder {
        color: var(--text-primary);
      }

      &,
      &:focus {
        border: none;
      }
    }

    .vs__dropdown-toggle {
      border: none;
      padding-bottom: 10px;
      padding-top: 3px;
      height: 40px;
    }

    .vs_search {
      display: none;
    }

    .vs__open-indicator {
      position: absolute;
      opacity: 0;
      right: 5px;
      top: 0;
      height: 100%;
      z-index: 1;
    }

    .vs__clear {
      margin-right: 18px;
      margin-top: 4px;
      fill: $text-secondary;
    }

    .vs__selected-options {
      position: relative;
      top: 1px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      flex-wrap: nowrap;
    }

    .vs__selected {
      margin-top: 5px;
      position: relative !important;
      display: block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: var(--text-primary);

      & + .vs__search {
        width: 0px;
        padding: 0;
      }
    }

    .vs__dropdown-menu {
      background-color: var(--bg);
    }

    .vs__dropdown-option {
      padding-left: 8px;
      padding-right: 8px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: var(--text-primary);

      &--highlight,
      &:hover {
        background-color: var(--lighter-primary);
      }
    }
  }
}
</style>
